import { render } from "./cardMessage.vue?vue&type=template&id=808b8630"
import script from "./cardMessage.vue?vue&type=script&lang=js"
export * from "./cardMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__